import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getTrainingSettings = (type: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `training-cert/training-settings?where=` +
      type
  );
};
export const addTrainingSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `training-cert/training-settings/create`,
    obj,
    { headers }
  );
};

export const editTrainingSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `training-cert/training-settings/update`,
    obj,
    { headers }
  );
};

export const deleteTrainingSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() +
      `training-cert/training-settings/delete`,
    obj,
    { headers }
  );
};
